import {
    SET_DEFAULT_PAYMENT_METHOD

} from './mutation.type'

export default {
    [SET_DEFAULT_PAYMENT_METHOD](state, defaultString) {
        state.defaultPaymentMethod = defaultString;
    }
}